export default __webpack_public_path__ + "static/dot-9b0d6e6451644f02bf85958ad6961cb3.png";